const locationOptions = [
    { id: "ab - calgary", label: "ab - calgary" },
    { id: "ab - edmonton", label: "ab - edmonton" },
    { id: "abilene (tx)", label: "abilene (tx)" },
    { id: "ace - carson (ca)", label: "ace - carson (ca)" },
    { id: "ace - perris (ca)", label: "ace - perris (ca)" },
    { id: "ace - perris 2 (ca)", label: "ace - perris 2 (ca)" },
    { id: "ak - anchorage", label: "ak - anchorage" },
    { id: "ak - anchorage south", label: "ak - anchorage south" },
    { id: "akron-canton (oh)", label: "akron-canton (oh)" },
    { id: "al - birmingham", label: "al - birmingham" },
    { id: "al - dothan", label: "al - dothan" },
    { id: "al - mobile", label: "al - mobile" },
    { id: "al - mobile south", label: "al - mobile south" },
    { id: "al - montgomery", label: "al - montgomery" },
    { id: "al - tanner", label: "al - tanner" },
    { id: "albany (ny)", label: "albany (ny)" },
    { id: "albuquerque (nm)", label: "albuquerque (nm)" },
    { id: "altoona (pa)", label: "altoona (pa)" },
    { id: "amarillo (tx)", label: "amarillo (tx)" },
    { id: "anaheim (ca)", label: "anaheim (ca)" },
    { id: "anaheim consolidated", label: "anaheim consolidated" },
    { id: "anchorage (ak)", label: "anchorage (ak)" },
    { id: "appleton (wi)", label: "appleton (wi)" },
    { id: "ar - fayetteville", label: "ar - fayetteville" },
    { id: "ar - little rock", label: "ar - little rock" },
    { id: "asheville (nc)", label: "asheville (nc)" },
    { id: "ashland (ky)", label: "ashland (ky)" },
    { id: "atlanta (ga)", label: "atlanta (ga)" },
    { id: "atlanta east (ga)", label: "atlanta east (ga)" },
    { id: "atlanta north (ga)", label: "atlanta north (ga)" },
    { id: "atlanta south (ga)", label: "atlanta south (ga)" },
    { id: "austin (tx)", label: "austin (tx)" },
    { id: "austin north (tx)", label: "austin north (tx)" },
    { id: "avenel new jersey (nj)", label: "avenel new jersey (nj)" },
    { id: "az - phoenix", label: "az - phoenix" },
    { id: "az - phoenix north", label: "az - phoenix north" },
    { id: "az - tucson", label: "az - tucson" },
    { id: "baltimore (md)", label: "baltimore (md)" },
    { id: "baton rouge (la)", label: "baton rouge (la)" },
    { id: "billings (mt)", label: "billings (mt)" },
    { id: "birmingham (al)", label: "birmingham (al)" },
    { id: "boise (id)", label: "boise (id)" },
    { id: "boston - shirley (ma)", label: "boston - shirley (ma)" },
    { id: "bowling green (ky)", label: "bowling green (ky)" },
    { id: "brandon (manitoba)", label: "brandon (manitoba)" },
    { id: "bridgeport (pa)", label: "bridgeport (pa)" },
    { id: "buckhannon (wv)", label: "buckhannon (wv)" },
    { id: "buffalo (ny)", label: "buffalo (ny)" },
    { id: "burlington (vt)", label: "burlington (vt)" },
    { id: "ca - adelanto", label: "ca - adelanto" },
    { id: "ca - antelope", label: "ca - antelope" },
    { id: "ca - bakersfield", label: "ca - bakersfield" },
    { id: "ca - fresno", label: "ca - fresno" },
    { id: "ca - hayward", label: "ca - hayward" },
    { id: "ca - long beach", label: "ca - long beach" },
    { id: "ca - los angeles", label: "ca - los angeles" },
    { id: "ca - martinez", label: "ca - martinez" },
    { id: "ca - mentone", label: "ca - mentone" },
    { id: "ca - rancho cucamonga", label: "ca - rancho cucamonga" },
    { id: "ca - redding", label: "ca - redding" },
    { id: "ca - sacramento", label: "ca - sacramento" },
    { id: "ca - san bernardino", label: "ca - san bernardino" },
    { id: "ca - san diego", label: "ca - san diego" },
    { id: "ca - san jose", label: "ca - san jose" },
    { id: "ca - so sacramento", label: "ca - so sacramento" },
    { id: "ca - sun valley", label: "ca - sun valley" },
    { id: "ca - vallejo", label: "ca - vallejo" },
    { id: "ca - van nuys", label: "ca - van nuys" },
    { id: "calgary south (alberta)", label: "calgary south (alberta)" },
    { id: "casper (wy)", label: "casper (wy)" },
    { id: "central new jersey (nj)", label: "central new jersey (nj)" },
    { id: "charleston (sc)", label: "charleston (sc)" },
    { id: "charlotte (nc)", label: "charlotte (nc)" },
    { id: "chattanooga (tn)", label: "chattanooga (tn)" },
    { id: "chicago-north (il)", label: "chicago-north (il)" },
    { id: "chicago-south (il)", label: "chicago-south (il)" },
    { id: "chicago-west (il)", label: "chicago-west (il)" },
    { id: "cincinnati (oh)", label: "cincinnati (oh)" },
    { id: "clearwater (fl)", label: "clearwater (fl)" },
    { id: "cleveland (oh)", label: "cleveland (oh)" },
    { id: "cn - canadian affiliates", label: "cn - canadian affiliates" },
    { id: "co - colorado springs", label: "co - colorado springs" },
    { id: "co - denver", label: "co - denver" },
    { id: "co - denver central", label: "co - denver central" },
    { id: "co - denver south", label: "co - denver south" },
    { id: "colorado springs (co)", label: "colorado springs (co)" },
    { id: "colton (ca)", label: "colton (ca)" },
    { id: "columbia (sc)", label: "columbia (sc)" },
    { id: "columbus (oh)", label: "columbus (oh)" },
    { id: "concord (nc)", label: "concord (nc)" },
    { id: "corpus christi (tx)", label: "corpus christi (tx)" },
    { id: "ct - hartford", label: "ct - hartford" },
    { id: "ct - hartford springfield", label: "ct - hartford springfield" },
    { id: "culpeper (va)", label: "culpeper (va)" },
    { id: "dallas (tx)", label: "dallas (tx)" },
    { id: "dallas/ft worth (tx)", label: "dallas/ft worth (tx)" },
    { id: "dallas/ft. worth old (tx)", label: "dallas/ft. worth old (tx)" },
    { id: "davenport (ia)", label: "davenport (ia)" },
    { id: "dayton (oh)", label: "dayton (oh)" },
    { id: "dc - washington dc", label: "dc - washington dc" },
    { id: "de - seaford", label: "de - seaford" },
    { id: "denver east (co)", label: "denver east (co)" },
    { id: "des moines (ia)", label: "des moines (ia)" },
    { id: "detroit (mi)", label: "detroit (mi)" },
    { id: "dothan (al)", label: "dothan (al)" },
    { id: "dundalk (md)", label: "dundalk (md)" },
    { id: "east bay (ca)", label: "east bay (ca)" },
    { id: "edmonton (alberta)", label: "edmonton (alberta)" },
    { id: "el paso (tx)", label: "el paso (tx)" },
    { id: "elkton (md)", label: "elkton (md)" },
    { id: "englishtown (nj)", label: "englishtown (nj)" },
    { id: "erie (pa)", label: "erie (pa)" },
    { id: "eugene (or)", label: "eugene (or)" },
    { id: "fargo (nd)", label: "fargo (nd)" },
    { id: "fayetteville (ar)", label: "fayetteville (ar)" },
    { id: "fl - ft. pierce", label: "fl - ft. pierce" },
    { id: "fl - jacksonville north", label: "fl - jacksonville north" },
    { id: "fl - miami central", label: "fl - miami central" },
    { id: "fl - miami north", label: "fl - miami north" },
    { id: "fl - miami south", label: "fl - miami south" },
    { id: "fl - ocala", label: "fl - ocala" },
    { id: "fl - orlando north", label: "fl - orlando north" },
    { id: "fl - orlando south", label: "fl - orlando south" },
    { id: "fl - punta gorda south", label: "fl - punta gorda south" },
    { id: "fl - tallahassee", label: "fl - tallahassee" },
    { id: "fl - tampa south", label: "fl - tampa south" },
    { id: "fl - west palm beach", label: "fl - west palm beach" },
    { id: "flint (mi)", label: "flint (mi)" },
    { id: "fontana (ca)", label: "fontana (ca)" },
    { id: "fort myers (fl)", label: "fort myers (fl)" },
    { id: "fort pierce (fl)", label: "fort pierce (fl)" },
    { id: "fort wayne (in)", label: "fort wayne (in)" },
    { id: "fort worth north (tx)", label: "fort worth north (tx)" },
    { id: "fremont (ca)", label: "fremont (ca)" },
    { id: "fresno (ca)", label: "fresno (ca)" },
    { id: "ga - atlanta east", label: "ga - atlanta east" },
    { id: "ga - atlanta north", label: "ga - atlanta north" },
    { id: "ga - atlanta south", label: "ga - atlanta south" },
    { id: "ga - atlanta west", label: "ga - atlanta west" },
    { id: "ga - augusta", label: "ga - augusta" },
    { id: "ga - cartersville", label: "ga - cartersville" },
    { id: "ga - fairburn", label: "ga - fairburn" },
    { id: "ga - macon", label: "ga - macon" },
    { id: "ga - savannah", label: "ga - savannah" },
    { id: "ga - tifton", label: "ga - tifton" },
    { id: "grand rapids (mi)", label: "grand rapids (mi)" },
    { id: "greensboro (nc)", label: "greensboro (nc)" },
    { id: "greenville (sc)", label: "greenville (sc)" },
    { id: "grenada (ms)", label: "grenada (ms)" },
    { id: "gulf coast (ms)", label: "gulf coast (ms)" },
    { id: "halifax (nova scotia)", label: "halifax (nova scotia)" },
    { id: "hamilton (ontario)", label: "hamilton (ontario)" },
    { id: "hartford (ct)", label: "hartford (ct)" },
    { id: "hi - honolulu", label: "hi - honolulu" },
    { id: "high desert (ca)", label: "high desert (ca)" },
    { id: "high point (nc)", label: "high point (nc)" },
    { id: "honolulu (hi)", label: "honolulu (hi)" },
    { id: "houston (tx)", label: "houston (tx)" },
    { id: "houston south (tx)", label: "houston south (tx)" },
    { id: "houston-north (tx)", label: "houston-north (tx)" },
    { id: "huntsville (al)", label: "huntsville (al)" },
    { id: "ia - davenport", label: "ia - davenport" },
    { id: "ia - des moines", label: "ia - des moines" },
    { id: "id - boise", label: "id - boise" },
    { id: "il - chicago north", label: "il - chicago north" },
    { id: "il - chicago south", label: "il - chicago south" },
    { id: "il - peoria", label: "il - peoria" },
    { id: "il - southern illinois", label: "il - southern illinois" },
    { id: "il - wheeling", label: "il - wheeling" },
    { id: "in - cicero", label: "in - cicero" },
    { id: "in - dyer", label: "in - dyer" },
    { id: "in - fort wayne", label: "in - fort wayne" },
    { id: "in - indianapolis", label: "in - indianapolis" },
    { id: "indianapolis (in)", label: "indianapolis (in)" },
    { id: "indianapolis south (crothersville) (in)", label: "indianapolis south (crothersville) (in)" },
    { id: "indianapolis south (in)", label: "indianapolis south (in)" },
    { id: "jackson (ms)", label: "jackson (ms)" },
    { id: "jacksonville (fl)", label: "jacksonville (fl)" },
    { id: "kansas city (ks)", label: "kansas city (ks)" },
    { id: "kansas city east (mo)", label: "kansas city east (mo)" },
    { id: "knoxville (tn)", label: "knoxville (tn)" },
    { id: "ks - kansas city", label: "ks - kansas city" },
    { id: "ks - wichita", label: "ks - wichita" },
    { id: "ky - earlington", label: "ky - earlington" },
    { id: "ky - lexington east", label: "ky - lexington east" },
    { id: "ky - lexington west", label: "ky - lexington west" },
    { id: "ky - louisville", label: "ky - louisville" },
    { id: "ky - walton", label: "ky - walton" },
    { id: "la - baton rouge", label: "la - baton rouge" },
    { id: "la - new orleans", label: "la - new orleans" },
    { id: "la - shreveport", label: "la - shreveport" },
    { id: "lafayette (la)", label: "lafayette (la)" },
    { id: "las vegas (nv)", label: "las vegas (nv)" },
    { id: "lexington (sc)", label: "lexington (sc)" },
    { id: "lincoln (il)", label: "lincoln (il)" },
    { id: "little rock (ar)", label: "little rock (ar)" },
    { id: "london (ontario)", label: "london (ontario)" },
    { id: "long island (ny)", label: "long island (ny)" },
    { id: "longview (tx)", label: "longview (tx)" },
    { id: "los angeles (ca)", label: "los angeles (ca)" },
    { id: "los angeles south (ca)", label: "los angeles south (ca)" },
    { id: "louisville north (ky)", label: "louisville north (ky)" },
    { id: "lubbock (tx)", label: "lubbock (tx)" },
    { id: "ma - freetown", label: "ma - freetown" },
    { id: "ma - north boston", label: "ma - north boston" },
    { id: "ma - south boston", label: "ma - south boston" },
    { id: "ma - west warren", label: "ma - west warren" },
    { id: "macon (ga)", label: "macon (ga)" },
    { id: "manchester (nh)", label: "manchester (nh)" },
    { id: "manitoba (manitoba)", label: "manitoba (manitoba)" },
    { id: "mcallen (tx)", label: "mcallen (tx)" },
    { id: "md - baltimore", label: "md - baltimore" },
    { id: "md - baltimore east", label: "md - baltimore east" },
    { id: "me - lyman", label: "me - lyman" },
    { id: "me - windham", label: "me - windham" },
    { id: "memphis (tn)", label: "memphis (tn)" },
    { id: "metro dc (md)", label: "metro dc (md)" },
    { id: "mi - detroit", label: "mi - detroit" },
    { id: "mi - flint", label: "mi - flint" },
    { id: "mi - ionia", label: "mi - ionia" },
    { id: "mi - kincheloe", label: "mi - kincheloe" },
    { id: "mi - lansing", label: "mi - lansing" },
    { id: "mi - wayland", label: "mi - wayland" },
    { id: "miami (fl)", label: "miami (fl)" },
    { id: "miami-north (fl)", label: "miami-north (fl)" },
    { id: "milwaukee (wi)", label: "milwaukee (wi)" },
    { id: "minneapolis south (mn)", label: "minneapolis south (mn)" },
    { id: "minneapolis/st. paul (mn)", label: "minneapolis/st. paul (mn)" },
    { id: "missoula (mt)", label: "missoula (mt)" },
    { id: "mn - minneapolis", label: "mn - minneapolis" },
    { id: "mn - minneapolis north", label: "mn - minneapolis north" },
    { id: "mn - st. cloud", label: "mn - st. cloud" },
    { id: "mo - columbia", label: "mo - columbia" },
    { id: "mo - sikeston", label: "mo - sikeston" },
    { id: "mo - springfield", label: "mo - springfield" },
    { id: "mo - st. louis", label: "mo - st. louis" },
    { id: "moncton (new brunswick)", label: "moncton (new brunswick)" },
    { id: "monticello (ny)", label: "monticello (ny)" },
    { id: "montreal (quebec)", label: "montreal (quebec)" },
    { id: "moose jaw (saskatchewan)", label: "moose jaw (saskatchewan)" },
    { id: "ms - grenada", label: "ms - grenada" },
    { id: "ms - jackson", label: "ms - jackson" },
    { id: "mt - billings", label: "mt - billings" },
    { id: "mt - helena", label: "mt - helena" },
    { id: "nashville (tn)", label: "nashville (tn)" },
    { id: "national network (me)", label: "national network (me)" },
    { id: "nb - moncton", label: "nb - moncton" },
    { id: "nc - china grove", label: "nc - china grove" },
    { id: "nc - concord", label: "nc - concord" },
    { id: "nc - gastonia", label: "nc - gastonia" },
    { id: "nc - lumberton", label: "nc - lumberton" },
    { id: "nc - mebane", label: "nc - mebane" },
    { id: "nc - mocksville", label: "nc - mocksville" },
    { id: "nc - raleigh", label: "nc - raleigh" },
    { id: "nc - raleigh north", label: "nc - raleigh north" },
    { id: "nd - bismarck", label: "nd - bismarck" },
    { id: "ne - lincoln", label: "ne - lincoln" },
    { id: "new castle (de)", label: "new castle (de)" },
    { id: "new orleans east (la)", label: "new orleans east (la)" },
    { id: "newburgh (ny)", label: "newburgh (ny)" },
    { id: "nh - candia", label: "nh - candia" },
    { id: "nj - glassboro east", label: "nj - glassboro east" },
    { id: "nj - glassboro west", label: "nj - glassboro west" },
    { id: "nj - somerville", label: "nj - somerville" },
    { id: "nj - trenton", label: "nj - trenton" },
    { id: "nl - st. john's", label: "nl - st. john's" },
    { id: "nm - albuquerque", label: "nm - albuquerque" },
    { id: "north battleford (saskatchewan)", label: "north battleford (saskatchewan)" },
    { id: "north hollywood (ca)", label: "north hollywood (ca)" },
    { id: "northern virginia (va)", label: "northern virginia (va)" },
    { id: "ns - halifax", label: "ns - halifax" },
    { id: "nv - 57 storage", label: "nv - 57 storage" },
    { id: "nv - las vegas", label: "nv - las vegas" },
    { id: "nv - las vegas west", label: "nv - las vegas west" },
    { id: "nv - reno", label: "nv - reno" },
    { id: "ny - albany", label: "ny - albany" },
    { id: "ny - buffalo", label: "ny - buffalo" },
    { id: "ny - long island", label: "ny - long island" },
    { id: "ny - newburgh", label: "ny - newburgh" },
    { id: "ny - rochester", label: "ny - rochester" },
    { id: "ny - syracuse", label: "ny - syracuse" },
    { id: "oh - akron", label: "oh - akron" },
    { id: "oh - cleveland east", label: "oh - cleveland east" },
    { id: "oh - cleveland west", label: "oh - cleveland west" },
    { id: "oh - columbus", label: "oh - columbus" },
    { id: "oh - dayton", label: "oh - dayton" },
    { id: "ok - oklahoma city", label: "ok - oklahoma city" },
    { id: "ok - tulsa", label: "ok - tulsa" },
    { id: "oklahoma city (ok)", label: "oklahoma city (ok)" },
    { id: "omaha (ne)", label: "omaha (ne)" },
    { id: "on - london", label: "on - london" },
    { id: "on - ottawa", label: "on - ottawa" },
    { id: "on - toronto", label: "on - toronto" },
    { id: "or - eugene", label: "or - eugene" },
    { id: "or - portland north", label: "or - portland north" },
    { id: "or - portland south", label: "or - portland south" },
    { id: "orlando (fl)", label: "orlando (fl)" },
    { id: "orlando-north (fl)", label: "orlando-north (fl)" },
    { id: "ottawa (ontario)", label: "ottawa (ontario)" },
    { id: "pa - altoona", label: "pa - altoona" },
    { id: "pa - chambersburg", label: "pa - chambersburg" },
    { id: "pa - harrisburg", label: "pa - harrisburg" },
    { id: "pa - philadelphia", label: "pa - philadelphia" },
    { id: "pa - philadelphia east-sublot", label: "pa - philadelphia east-sublot" },
    { id: "pa - pittsburgh north", label: "pa - pittsburgh north" },
    { id: "pa - pittsburgh south", label: "pa - pittsburgh south" },
    { id: "pa - pittsburgh west", label: "pa - pittsburgh west" },
    { id: "pa - scranton", label: "pa - scranton" },
    { id: "pa - york haven", label: "pa - york haven" },
    { id: "paducah (ky)", label: "paducah (ky)" },
    { id: "pensacola (fl)", label: "pensacola (fl)" },
    { id: "permian basin (tx)", label: "permian basin (tx)" },
    { id: "philadelphia (pa)", label: "philadelphia (pa)" },
    { id: "phoenix (az)", label: "phoenix (az)" },
    { id: "pittsburgh (pa)", label: "pittsburgh (pa)" },
    { id: "pittsburgh-north (pa)", label: "pittsburgh-north (pa)" },
    { id: "port murray (nj)", label: "port murray (nj)" },
    { id: "portage (wi)", label: "portage (wi)" },
    { id: "portland - gorham (me)", label: "portland - gorham (me)" },
    { id: "portland (or)", label: "portland (or)" },
    { id: "portland south (or)", label: "portland south (or)" },
    { id: "portland west (or)", label: "portland west (or)" },
    { id: "prince albert (saskatchewan)", label: "prince albert (saskatchewan)" },
    { id: "providence (ri)", label: "providence (ri)" },
    { id: "provo (ut)", label: "provo (ut)" },
    { id: "pulaski (va)", label: "pulaski (va)" },
    { id: "qc - montreal", label: "qc - montreal" },
    { id: "quebec city (quebec)", label: "quebec city (quebec)" },
    { id: "raleigh (nc)", label: "raleigh (nc)" },
    { id: "regina (saskatchewan)", label: "regina (saskatchewan)" },
    { id: "reno (nv)", label: "reno (nv)" },
    { id: "ri - exeter", label: "ri - exeter" },
    { id: "richmond (va)", label: "richmond (va)" },
    { id: "riverside (ca)", label: "riverside (ca)" },
    { id: "roanoke (va)", label: "roanoke (va)" },
    { id: "rochester (ny)", label: "rochester (ny)" },
    { id: "sacramento (ca)", label: "sacramento (ca)" },
    { id: "salt lake city (ut)", label: "salt lake city (ut)" },
    { id: "san antonio-south (tx)", label: "san antonio-south (tx)" },
    { id: "san diego (ca)", label: "san diego (ca)" },
    { id: "santa clarita (ca)", label: "santa clarita (ca)" },
    { id: "saskatoon (saskatchewan)", label: "saskatoon (saskatchewan)" },
    { id: "savannah (ga)", label: "savannah (ga)" },
    { id: "sayreville (nj)", label: "sayreville (nj)" },
    { id: "sc - columbia", label: "sc - columbia" },
    { id: "sc - north charleston", label: "sc - north charleston" },
    { id: "sc - spartanburg", label: "sc - spartanburg" },
    { id: "scranton (pa)", label: "scranton (pa)" },
    { id: "sd - rapid city", label: "sd - rapid city" },
    { id: "seattle (wa)", label: "seattle (wa)" },
    { id: "shady spring (wv)", label: "shady spring (wv)" },
    { id: "shreveport (la)", label: "shreveport (la)" },
    { id: "sioux falls (sd)", label: "sioux falls (sd)" },
    { id: "south bend (in)", label: "south bend (in)" },
    { id: "southern new jersey (nj)", label: "southern new jersey (nj)" },
    { id: "specialty division (il)", label: "specialty division (il)" },
    { id: "spokane (wa)", label: "spokane (wa)" },
    { id: "springfield (mo)", label: "springfield (mo)" },
    { id: "st. cloud (mn)", label: "st. cloud (mn)" },
    { id: "st. john's (newfoundland and labrador)", label: "st. john's (newfoundland and labrador)" },
    { id: "st. louis (il)", label: "st. louis (il)" },
    { id: "staten island (ny)", label: "staten island (ny)" },
    { id: "stockton (ca)", label: "stockton (ca)" },
    { id: "sudbury (ontario)", label: "sudbury (ontario)" },
    { id: "suffolk (va)", label: "suffolk (va)" },
    { id: "syracuse (ny)", label: "syracuse (ny)" },
    { id: "tampa (fl)", label: "tampa (fl)" },
    { id: "tampa north (fl)", label: "tampa north (fl)" },
    { id: "taunton (ma)", label: "taunton (ma)" },
    { id: "templeton (ma)", label: "templeton (ma)" },
    { id: "tidewater (va)", label: "tidewater (va)" },
    { id: "tifton (ga)", label: "tifton (ga)" },
    { id: "title center (wa) (wa)", label: "title center (wa) (wa)" },
    { id: "title procurement (in)", label: "title procurement (in)" },
    { id: "tn - knoxville", label: "tn - knoxville" },
    { id: "tn - memphis", label: "tn - memphis" },
    { id: "tn - nashville", label: "tn - nashville" },
    { id: "toronto (ontario)", label: "toronto (ontario)" },
    { id: "toronto north (ontario)", label: "toronto north (ontario)" },
    { id: "tucson (az)", label: "tucson (az)" },
    { id: "tulsa (ok)", label: "tulsa (ok)" },
    { id: "tx - abilene", label: "tx - abilene" },
    { id: "tx - amarillo", label: "tx - amarillo" },
    { id: "tx - andrews", label: "tx - andrews" },
    { id: "tx - austin", label: "tx - austin" },
    { id: "tx - corpus christi", label: "tx - corpus christi" },
    { id: "tx - crashedtoys dallas", label: "tx - crashedtoys dallas" },
    { id: "tx - dallas", label: "tx - dallas" },
    { id: "tx - dallas south", label: "tx - dallas south" },
    { id: "tx - el paso", label: "tx - el paso" },
    { id: "tx - ft. worth", label: "tx - ft. worth" },
    { id: "tx - houston", label: "tx - houston" },
    { id: "tx - houston east", label: "tx - houston east" },
    { id: "tx - longview", label: "tx - longview" },
    { id: "tx - lufkin", label: "tx - lufkin" },
    { id: "tx - mcallen", label: "tx - mcallen" },
    { id: "tx - san antonio", label: "tx - san antonio" },
    { id: "tx - waco", label: "tx - waco" },
    { id: "ut - ogden", label: "ut - ogden" },
    { id: "ut - salt lake city", label: "ut - salt lake city" },
    { id: "va - danville", label: "va - danville" },
    { id: "va - fredericksburg", label: "va - fredericksburg" },
    { id: "va - hampton", label: "va - hampton" },
    { id: "va - richmond", label: "va - richmond" },
    { id: "va - richmond east", label: "va - richmond east" },
    { id: "vancouver (british columbia)", label: "vancouver (british columbia)" },
    { id: "vt - rutland", label: "vt - rutland" },
    { id: "wa - graham", label: "wa - graham" },
    { id: "wa - north seattle", label: "wa - north seattle" },
    { id: "wa - pasco", label: "wa - pasco" },
    { id: "wa - spokane", label: "wa - spokane" },
    { id: "west palm beach (fl)", label: "west palm beach (fl)" },
    { id: "western colorado (co)", label: "western colorado (co)" },
    { id: "wi - appleton", label: "wi - appleton" },
    { id: "wi - madison south", label: "wi - madison south" },
    { id: "wi - milwaukee north", label: "wi - milwaukee north" },
    { id: "wi - milwaukee south", label: "wi - milwaukee south" },
    { id: "wichita (ks)", label: "wichita (ks)" },
    { id: "wilmington (nc)", label: "wilmington (nc)" },
    { id: "winnipeg (manitoba)", label: "winnipeg (manitoba)" },
    { id: "wv - charleston", label: "wv - charleston" },
    { id: "wy - casper", label: "wy - casper" },
    { id: "york springs (pa)", label: "york springs (pa)" },
    { id: "yorkton (saskatchewan)", label: "yorkton (saskatchewan)" }
    
  ];
  
   // API key
   const locationAPIKey = "location"; 
  
   // Label
   const locationLabel = "Location"; 
   
   export { locationOptions, locationAPIKey, locationLabel };
   